import { render, staticRenderFns } from "./BusClsTariffForm.vue?vue&type=template&id=4a8bf1b5&"
import script from "./BusClsTariffForm.vue?vue&type=script&lang=js&"
export * from "./BusClsTariffForm.vue?vue&type=script&lang=js&"
import style0 from "./BusClsTariffForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusClsTariffForm.vue"
export default component.exports